export const SUCCESS = 'SUCCESS';
export const COMPLETE = 'COMPLETE';
export const LOADING = 'LOADING';
export const FAILURE = 'FAILURE';
export const INITIAL = 'INITIAL';
export const PENDING = 'PENDING';



// WEBPACK FOOTER //
// ./src/constants/status.js